import { render } from "./commercialManagerScreen.vue?vue&type=template&id=189d6e4c"
import script from "./commercialManagerScreen.vue?vue&type=script&lang=js"
export * from "./commercialManagerScreen.vue?vue&type=script&lang=js"

import "./commercialManagerScreen.vue?vue&type=style&index=0&id=189d6e4c&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__